import type AgentApiAiJobSearchRunsResult from '@/types/serializers/AgentApiAiJobSearchRunsResult';

export type RecommendationView = {
  source: AgentApiAiJobSearchRunsResult['source'];
  title: string;
  companyName: string | null;
  jobPositionName: string | null;
  salaryInfo: string | null;
  workingLocation: string | null;
};

/** 自社求人・求人DBのどちらの結果も同じ表示項目に正規化する */
export default function toRecommendationView(
  result: AgentApiAiJobSearchRunsResult
): RecommendationView | null {
  const { provided_job_post: provided, shared_job_post: shared } = result;
  if (result.source === 'shared' && shared) {
    return {
      source: 'shared',
      title: shared.title,
      companyName: shared.company_name,
      jobPositionName: shared.job_position_name,
      salaryInfo: shared.salary_info,
      workingLocation: shared.working_location_label,
    };
  }
  if (provided) {
    return {
      source: 'provided',
      title: provided.title,
      companyName: provided.company?.name ?? null,
      jobPositionName: provided.job_position_name,
      salaryInfo: provided.salary_info,
      workingLocation: provided.working_location,
    };
  }
  return null;
}
